import React from "react";
const MVMIcon = ({ icon, className, height = 32, width = 32, }) => {
    const viewBox = `0 0 ${width} ${height}`;
    return (React.createElement("svg", { className: `primary-color ${className}`, width: `${width}px`, height: `${height}px`, viewBox: viewBox, fill: "currentColor" },
        React.createElement("use", { xlinkHref: `/public/icons/mvm-icons.svg#${icon}` })));
};
export default MVMIcon;
